export const enum BillingPeriod {
  MONTHLY = "monthly",
  ANNUAL = "yearly",
}

export const enum ProductPriceName {
  FREE = "Free",
  PRO = "Pro",
  PRO_PLUS_CERTS = "Certifications Plan",
}

export type ProductPrice = {
  name: ProductPriceName;
  price: {
    [BillingPeriod.ANNUAL]: string;
    [BillingPeriod.MONTHLY]: string;
  };
  description: string;
  cta: string;
  features: string[];
};

export const ProductPrices: ProductPrice[] = [
  {
    name: ProductPriceName.FREE,
    price: {
      yearly: "$0",
      monthly: "$0",
    },
    description: "Everything you need to get started as a beginner learner.",
    cta: "Start learning",
    features: [
      "Explore a wide range of beginner friendly projects",
      "Basic Project Documentation generation",
      "Showcase x3 projects in your Portfolio",
    ],
  },
  {
    name: ProductPriceName.PRO,
    price: {
      yearly: "$8.25",
      monthly: "$11.99",
    },
    description: "Showcase your skills with more advanced topics and tools for learning.",
    cta: "Become a Pro",
    features: [
      "Everything in free plus",
      "Pro Projects on advanced topics",
      "Unlimited Portfolio access",
      "Test your knowledge with unlimited project quizzes",
    ],
  },
  {
    name: ProductPriceName.PRO_PLUS_CERTS,
    price: {
      monthly: "$39.99",
      yearly: "$39.99",
    },
    description: "Save on Pro and hit your certification goals!",
    cta: "Buy plan",
    features: [
      "Everything in Pro plus",
      "2 x Associate AWS Certification Vouchers per year",
      "1 x Foundational AWS Certification Voucher per year",
    ],
  },
];
